var map = {
	"./Goldstreifen-MENU_mobil-390px.png": 6681,
	"./Goldstreifen-mobil-schmal.png": 9249,
	"./Goldstreifen-mobil.png": 6326,
	"./faces.svg": 3807,
	"./forbes-logo-white-luxury-summit-2024.svg": 3377,
	"./goldstreifen-desktop-schmal.png": 5502,
	"./goldstreifen-desktop.png": 4607,
	"./kier-in-sight-archives-shLU6SZfIQY-unsplash.jpg": 6305,
	"./schoki-desktop.png": 6890,
	"./schokoladentafel-390px.png": 4084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1701;